function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const fetchProductDetails = async (productId) => {
    const storefrontAccessToken = window.adminToken;
    try {
      const response = await fetch(
        `https://${Shopify.shop}/admin/api/2024-04/graphql.json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Access-Token": storefrontAccessToken,
          },
          body: JSON.stringify({
            query: `{
                      node(id: "${productId}") {
                          ... on Product {
                              title
                              handle
                              metafield(namespace: "custom", key: "discontinued") {
                                  value
                                  type
                              }
                              images(first: 2) {
                                  edges {
                                      node {
                                          src
                                          altText
                                      }
                                  }
                              }
                              variants(first: 50) {
                                  edges {
                                      node {
                                          id
                                          title
                                          inventoryPolicy
                                          inventoryQuantity
                                          selectedOptions {
                                              name
                                              value
                                          }
                                          image {
                                              src
                                              altText
                                          }
                                      }
                                  }
                              }
                          }
                      }
                  }`,
          }),
        }
      );
      const data = await response.json();
      if (data && data.data && data.data.node) {
        return data.data.node;
      } else {
        return "";
      }
    } catch (error) {
      throw error;
    }
  };

  const processProductDetails = async (
    product,
    featuredImageId,
    productDataElements,
    productId,
    primaryImagesrc,
    secondaryImagesrc,
    mainHandle,
    uniqueColors,
    counter
  ) => {
    if (product && product.variants && product.variants.edges) {
      for (const edge of product.variants.edges) {
        const variant = edge.node;
        if (variant && variant.inventoryQuantity > 0) {
          let variantColor = null;

          if (product.color && product.color.references && product.color.references.edges.length > 0) {
            const colorReference = product.color.references.edges[0].node;
            const labelField = colorReference.fields.find(f => f.key === 'label');
            if (labelField) {
              variantColor = labelField.value;
            }
          }

          if (!variantColor) {
            for (const option of variant.selectedOptions) {
              if (
                option.name.toLowerCase() === "color" ||
                option.name.toLowerCase() === "colour" ||
                option.name.toLowerCase() === "couleur"
              ) {
                variantColor = option.value;
                break;
              }
            }
          }

          if (variantColor && !uniqueColors.has(variantColor) && counter.count < 6) {
            uniqueColors.set(variantColor, { value: variantColor });

            let swatchHtml = "";
            let active = "";
            let variantImage = "";
            let variantUrl = "";
            let srcset = "";
            let variantId = parseInt(variant.id.split("/").pop());

            if (variant) {
              if (variantId === featuredImageId) active = "active";
              if (primaryImagesrc) variantImage = primaryImagesrc;
              variantUrl = `/products/${product.handle}?variant=${variantId}`;
            }

            const imageSizes = "{{ sizes }}".split(",");
            if (variantImage) {
              imageSizes.forEach((size) => {
                const sizeArray = size.split("x");
                const sizeX = sizeArray[0] + "x" + (sizeArray[1] !== "0" ? sizeArray[1] : "");
                srcset += `${variantImage.replace(".jpg", `_${sizeX}.jpg`)} ${sizeArray[0]}w, `;
              });
            }

            let colorValue = variantColor.toLowerCase().trim();
            let bgValue = false;
            if (colorValue.includes(".")) {
              bgValue = colorValue;
              colorValue = "var(--bg-body)";
            }

            const shopDomain = window.location.hostname;
            const bgImageUrl = bgValue ? `--option-color-image: url('//${shopDomain}/cdn/shop/files/${bgValue}');` : "";

            swatchHtml += `
              <div class="product-card-swatch ${active}"
                style="--option-color: ${colorValue}; ${bgImageUrl}"
                data-srcset-2="${secondaryImagesrc}"
                data-srcset="${variantImage}"
                data-href="${variantUrl}"
                data-color="${variantColor}"
                data-color-taxonomy="${variantColor.toLowerCase()}"
              >
                <span class="visually-hidden">${variantColor}</span>
              </div>
            `;

            productDataElements.insertAdjacentHTML("beforeend", swatchHtml);
            counter.count++;
          }
          if (counter.count >= 6) break;
        }
      }
      if (uniqueColors.size > 5 && counter.count >= 5) {
        const moreButtonHtml = `<div class="morebtn"><a href="/products/${mainHandle}" intellisuggest="" ss-ps="">+ More</a></div>`;
        productDataElements.insertAdjacentHTML("beforeend", moreButtonHtml);
      }
    }
  };

class FacetsToggle {
  constructor() {
    this.container = document.getElementById("Facet-Drawer");
    let button = document.getElementById("Facets-Toggle");
    if (button) {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle("open-cc");
        this.container.classList.toggle("active");
      });
    }
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    // Enforce single-select for Band (filter.p.m.*) and Cup filters.
    // Intercept change (fires before the debounced submit) and uncheck all
    // siblings with the same name so only the clicked value survives.
    this.querySelector('form').addEventListener('change', (e) => {
      const input = e.target;
      if (input.type !== 'checkbox' || !input.checked) return;
      const isSingleSelect =
        input.name?.startsWith('filter.p.m.') ||
        input.name?.toLowerCase().includes('cup');
      if (!isSingleSelect) return;
      this.querySelectorAll(`input[type="checkbox"][name="${CSS.escape(input.name)}"]`).forEach(cb => {
        if (cb !== input) cb.checked = false;
      });
    });

    this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));

    this.addEventListener("click", (e) => {
      const reset = e.target.closest("a.facets__reset");
      if (!reset || !this.contains(reset)) return;
      e.preventDefault();
      document.getElementsByTagName("body")[0].classList.remove("open-cc");
      const drawer = document.getElementById("Facet-Drawer");
      if (drawer) drawer.classList.remove("active");
      const href = reset.href;
      const url = href.indexOf("?") === -1 ? "" : href.slice(href.indexOf("?") + 1);
      FacetFiltersForm.renderPage(url, null);
    });

    FacetFiltersForm.updateFilteredProducts(true);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);

    document.body.addEventListener('click', function (e) {
      const target = e.target;
      if (target.classList.contains('swatch-btn')) {
        FacetFiltersForm.updateSwatchInfo(target);
      }
      const mobileClear = target.closest('a.mobile-filters-clear');
      if (mobileClear) {
        e.preventDefault();
        document.getElementsByTagName('body')[0].classList.remove('open-cc');
        const drawer = document.getElementById('Facet-Drawer');
        if (drawer) drawer.classList.remove('active');
        FacetFiltersForm.toggleActiveFacets();
        const href = mobileClear.href;
        const url = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);
        FacetFiltersForm.renderPage(url, null);
      }
    });

    const onResize = debounce((event) => {
      let root = document.documentElement,
        header = document.querySelector(".header"),
        height = header.clientHeight;
      if (window.innerWidth <= 768) {
        root.style.setProperty("--header-height-mobile", height + "px");
      }
    }, 200);
    window.addEventListener("resize", onResize);
    window.dispatchEvent(new Event("resize"));
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static updateSwatchInfo(swatchEl) {
    let productCard = swatchEl.closest('.card-wrapper');
    productCard.querySelectorAll('.swatch-btn').forEach((btn) => btn.classList.remove('active'));
    swatchEl.classList.add('active');

    let newSrc = swatchEl.dataset.src;
    let newSrcset = swatchEl.dataset.srcset;
    let newSrcAlt = swatchEl.dataset.srcalt || '';
    let newSrcsetAlt = swatchEl.dataset.srcsetalt || '';
    let newUrl = swatchEl.dataset.url;
    let newPrice = swatchEl.dataset.price;
    let newPriceNum = swatchEl.dataset.priceNum;
    let newComparePrice = swatchEl.dataset.comparePrice;
    let card_image = productCard.querySelector('.product-primary-image');
    let card_image_secondary = productCard.querySelector('.product-secondary-image');
    let card_del = productCard.querySelector('.price > del');
    const isSale = newComparePrice !== newPriceNum;

    if (newUrl) productCard.querySelectorAll('a').forEach(link => link.setAttribute('href', newUrl));
    if (card_image && card_image.src != newSrc) {
      card_image.setAttribute('src', newSrc);
      card_image.setAttribute('data-srcset', newSrcset);
      card_image.setAttribute('srcset', newSrcset);
    }
    if (card_image_secondary && card_image_secondary.src != newSrcAlt) {
      card_image_secondary.setAttribute('src', newSrcAlt);
      card_image_secondary.setAttribute('data-srcset', newSrcsetAlt);
      card_image_secondary.setAttribute('srcset', newSrcsetAlt);
    }
    if (newPrice) productCard.querySelector('.amount.amount-single').innerHTML = newPrice;
    if (card_del) card_del.style.display = isSale ? 'block' : 'none';
  }

  static buildSizeGidMap() {
    const sizeGidMap = {};
    document.querySelectorAll('.js-filter').forEach(filter => {
      const summary = filter.querySelector('summary')?.textContent?.trim().toLowerCase();
      if (summary?.includes('size')) {
        filter.querySelectorAll('input[type="checkbox"]').forEach(input => {
          if (input.value && input.name?.includes('available_sizes')) {
            const li = input.closest('li') || input.closest('label');
            const labelEl = li?.querySelector('.facets__label, label span, .filter-label');
            let label = '';
            if (labelEl) {
              label = labelEl.textContent.trim();
            } else {
              label = (li || input.parentElement)?.textContent?.trim() || '';
            }
            const match = label.match(/\(([^)]+)\)/);
            if (match) {
              sizeGidMap[input.value] = match[1].trim();
            } else if (label) {
              sizeGidMap[input.value] = label.replace(/\s*\(\d+\)\s*$/, '').trim();
            }
          }
        });
      }
    });
    return sizeGidMap;
  }


  static buildSizeGidMapByName(namePattern) {
    const gidMap = {};
    document.querySelectorAll('.js-filter input[type="checkbox"]').forEach(input => {
      if (input.value && input.name?.toLowerCase().includes(namePattern.toLowerCase())) {
        const li = input.closest('li') || input.closest('label');
        const labelEl = li?.querySelector('.facets__label, label span, .filter-label');
        let label = '';
        if (labelEl) {
          label = labelEl.textContent.trim();
        } else {
          label = (li || input.parentElement)?.textContent?.trim() || '';
        }
        if (label) {
          // Strip trailing count like " (17)" to get the actual size label e.g. "32"
          gidMap[input.value] = label.replace(/\s*\(\d+\)\s*$/, '').trim();
        }
      }
    });
    return gidMap;
  }

  static updateFilteredProducts(onLoad) {
    if (onLoad) {
      document.querySelectorAll('.swatch-btn.active').forEach(swatchEl => FacetFiltersForm.updateSwatchInfo(swatchEl));
    }

    // Hide filter counts when filters are active to avoid showing misleading numbers
    const hasActiveFilters = window.location.search.includes('filter.');
    document.querySelectorAll('.count').forEach(el => {
      el.style.display = hasActiveFilters ? 'none' : '';
    });

    const filters = FacetFiltersForm.getFilters();

    const colorFilters = filters?.filter(f => f.key == 'custom.available_colors').map(f => f.value);
    const sizeFilters = filters?.filter(f => f.key == 'custom.available_sizes').map(f => f.value);
    const hasColorFilter = !!colorFilters?.length;
    const hasSizeFilter = !!sizeFilters?.length;

    // Price filter — values come in as cents (e.g. 2600 = $26.00)
    const priceGte = filters?.find(f => f.key === 'price.gte')?.value;
    const priceLte = filters?.find(f => f.key === 'price.lte')?.value;
    const hasPriceFilter = !!(priceGte || priceLte);
    // URL price params are in dollars (e.g. 14.00), data-price-num is in cents (e.g. 1400)
    const priceMin = priceGte ? parseFloat(priceGte) * 100 : 0;
    const priceMax = priceLte ? parseFloat(priceLte) * 100 : Infinity;


    let activeSizeLabels = [];
    if (hasSizeFilter) {
      const sizeGidMap = FacetFiltersForm.buildSizeGidMap();
      activeSizeLabels = sizeFilters.map(gid => sizeGidMap[gid]).filter(Boolean);
    }


    const bandFilterValues = filters?.filter(f => f.key.toLowerCase().includes('band')).map(f => f.value) || [];
    const cupFilterValues = filters?.filter(f => f.key.toLowerCase().includes('cup')).map(f => f.value) || [];
    const hasBandFilter = bandFilterValues.length > 0;
    const hasCupFilter = cupFilterValues.length > 0;
    const hasCombinedSizeFilter = hasBandFilter || hasCupFilter;

    let activeBandLabels = [];
    if (hasBandFilter) {
      const bandGidMap = FacetFiltersForm.buildSizeGidMapByName('band');
      activeBandLabels = bandFilterValues.map(gid => bandGidMap[gid]).filter(Boolean);
    }

    let activeCupLabels = [];
    if (hasCupFilter) {
      const cupGidMap = FacetFiltersForm.buildSizeGidMapByName('cup');
      activeCupLabels = cupFilterValues.map(gid => cupGidMap[gid]).filter(Boolean);
    }

    if (hasColorFilter || hasSizeFilter || hasPriceFilter || hasCombinedSizeFilter) {
      const filterInt = setInterval(() => {
        const isLoading = document.querySelector('#ProductGridContainer .collection')?.classList.contains('loading');
        if (!isLoading) {

          // Color filter — update active swatch to match filtered color
          if (hasColorFilter) {
          }
          document.querySelectorAll('.product-swatches').forEach((swatchContainer) => {
            const productCard = swatchContainer.closest('product-card') || swatchContainer.closest('.product-card');
            const productTitle = productCard?.querySelector('.product-card-title')?.textContent?.trim() || 'Unknown product';
            let filteredItems = [];
            let matchesBoth = [];

            swatchContainer.querySelectorAll('.swatch-btn').forEach((swatchBtn) => {
              const colorTaxonomy = swatchBtn.dataset.colorTaxonomy;
              let isValidColor;

              if (hasColorFilter) {
                const colorTaxonomyArr = (colorTaxonomy || '').split(',');
                isValidColor = colorTaxonomyArr.some(taxonomy => colorFilters.includes(taxonomy));
                if (isValidColor) filteredItems.push(swatchBtn);
              }

              if (isValidColor) matchesBoth.push(swatchBtn);
            });

            if (hasColorFilter) {
              if (filteredItems.length === 0) {
              } else {
              }
            }

            if (matchesBoth.length) {
              FacetFiltersForm.updateSwatchInfo(matchesBoth[0]);
            } else if (filteredItems.length) {
              FacetFiltersForm.updateSwatchInfo(filteredItems[0]);
            }
          });

          // Size filter — hide swatches and cards without the filtered size in stock
          if (hasSizeFilter && activeSizeLabels.length) {
            document.querySelectorAll('.product-swatches').forEach((swatchContainer) => {
              const productCard = swatchContainer.closest('product-card') || swatchContainer.closest('.product-card');
              const productTitle = productCard?.querySelector('.product-card-title')?.textContent?.trim() || 'Unknown product';
              let hasAnyVisibleSwatch = false;

              swatchContainer.querySelectorAll('.swatch-btn').forEach((swatchBtn) => {
                const availableSizes = (swatchBtn.dataset.availableSizes || '').split(',').map(s => s.trim());
                const hasFilteredSize = activeSizeLabels.some(size => availableSizes.includes(size));
                if (!hasFilteredSize) {
                  swatchBtn.style.display = 'none';
                } else {
                  swatchBtn.style.display = '';
                  hasAnyVisibleSwatch = true;
                }
              });

              if (!hasAnyVisibleSwatch) {
              } else {
              }

              if (!hasAnyVisibleSwatch && productCard) {
                productCard.closest('li')?.style.setProperty('display', 'none');
                productCard.classList.add('filtered-out');
              } else if (productCard) {
                productCard.closest('li')?.style.removeProperty('display');
                productCard.classList.remove('filtered-out');
                const activeSwatch = swatchContainer.querySelector('.swatch-btn.active');
                if (activeSwatch && activeSwatch.style.display === 'none') {
                  const firstVisible = swatchContainer.querySelector('.swatch-btn:not([style*="display: none"])');
                  if (firstVisible) FacetFiltersForm.updateSwatchInfo(firstVisible);
                }
              }
            });
          }

          // Price filter — hide swatches outside price range, hide card if all swatches are out of range
          if (hasPriceFilter) {
            document.querySelectorAll('.product-swatches').forEach((swatchContainer) => {
              const productCard = swatchContainer.closest('product-card') || swatchContainer.closest('.product-card');
              const productTitle = productCard?.querySelector('.product-card-title')?.textContent?.trim() || 'Unknown product';
              let hasAnyVisibleSwatch = false;

              swatchContainer.querySelectorAll('.swatch-btn').forEach((swatchBtn) => {
                // Skip already-hidden swatches (from size filter)
                if (swatchBtn.style.display === 'none') {
                  return;
                }

                const swatchPrice = parseFloat(swatchBtn.dataset.priceNum || 0);
                const inRange = swatchPrice >= priceMin && swatchPrice <= priceMax;

                if (!inRange) {
                  swatchBtn.style.display = 'none';
                } else {
                  hasAnyVisibleSwatch = true;
                }
              });

              if (productCard) {
                const activeSwatch = swatchContainer.querySelector('.swatch-btn.active');
                if (activeSwatch && activeSwatch.style.display === 'none') {
                  const firstVisible = swatchContainer.querySelector('.swatch-btn:not([style*="display: none"])');
                  if (firstVisible) FacetFiltersForm.updateSwatchInfo(firstVisible);
                }

                if (!hasAnyVisibleSwatch) {
                  productCard.closest('li')?.style.setProperty('display', 'none');
                  productCard.classList.add('filtered-out');
                } else {
                  productCard.closest('li')?.style.removeProperty('display');
                  productCard.classList.remove('filtered-out');
                }
              }
            });
          }


          // Runs after size/price filters so already-hidden swatches are respected.
          if (hasCombinedSizeFilter) {
            const getBandFromSize = (size) => {
              const m = size.match(/^(\d+)/);
              return m ? m[1] : null;
            };
            const getCupFromSize = (size) => {
              const m = size.match(/^(\d+)([A-Za-z]+)$/);
              return m ? m[2].toUpperCase() : null;
            };

            document.querySelectorAll('.product-swatches').forEach((swatchContainer) => {
              const productCard = swatchContainer.closest('product-card') || swatchContainer.closest('.product-card');
              let hasAnyVisibleSwatch = false;

              swatchContainer.querySelectorAll('.swatch-btn').forEach((swatchBtn) => {
                if (swatchBtn.style.display === 'none') return;

                const rawSizes = swatchBtn.dataset.availableSizes || '';
                const availableSizes = rawSizes.split(',').map(s => s.trim()).filter(Boolean);

                if (availableSizes.length === 0) {
                  swatchBtn.style.display = 'none';
                  return;
                }

                if (activeBandLabels.length && activeCupLabels.length) {
                  const hasCombo = activeBandLabels.some(band =>
                    activeCupLabels.some(cup => availableSizes.includes(band + cup))
                  );
                  if (!hasCombo) {
                    swatchBtn.style.display = 'none';
                    return;
                  }
                } else if (activeBandLabels.length) {
                  const hasMatchingBand = activeBandLabels.some(band =>
                    availableSizes.some(size => getBandFromSize(size) === band || size === band)
                  );
                  if (!hasMatchingBand) {
                    swatchBtn.style.display = 'none';
                    return;
                  }
                } else if (activeCupLabels.length) {
                  const hasMatchingCup = activeCupLabels.some(cup =>
                    availableSizes.some(size => {
                      const extracted = getCupFromSize(size);
                      return extracted === cup.toUpperCase() || size === cup;
                    })
                  );
                  if (!hasMatchingCup) {
                    swatchBtn.style.display = 'none';
                    return;
                  }
                }

                hasAnyVisibleSwatch = true;
              });

              if (!hasAnyVisibleSwatch && productCard) {
                productCard.closest('li')?.style.setProperty('display', 'none');
                productCard.classList.add('filtered-out');
              } else if (productCard) {
                productCard.closest('li')?.style.removeProperty('display');
                productCard.classList.remove('filtered-out');
                const activeSwatch = swatchContainer.querySelector('.swatch-btn.active');
                if (activeSwatch && activeSwatch.style.display === 'none') {
                  const firstVisible = swatchContainer.querySelector('.swatch-btn:not([style*="display: none"])');
                  if (firstVisible) FacetFiltersForm.updateSwatchInfo(firstVisible);
                }
              }
            });
          }

          FacetFiltersForm.updateFilteredProductCount();
          const visibleCount = document.querySelectorAll('#product-grid li:not([style*="display: none"])').length;
          FacetFiltersForm.showNoResultsIfEmpty(visibleCount);
          clearInterval(filterInt);
        }
      }, 500);
    } else {
      // No filters — reset everything
      document.querySelectorAll('.product-card.filtered-out').forEach(card => {
        card.closest('li')?.style.removeProperty('display');
        card.classList.remove('filtered-out');
      });
      document.querySelectorAll('.swatch-btn').forEach(btn => btn.style.display = '');
      document.querySelectorAll('#product-grid li[style*="display: none"]').forEach(li => li.style.removeProperty('display'));
      FacetFiltersForm.updateFilteredProductCount();
    }
  }

  static getFilters(filterKey = false) {
    const params = new URLSearchParams(window.location.search);
    let filters = [];
    params.forEach((value, key) => {
      if (!filterKey || key == filterKey) {
        const formattedKey = key.replace('filter.v.t.', '').replace('filter.v.', '');
        filters.push(filterKey ? value : { key: formattedKey, value });
      }
    });
    return filters;
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    if (sections.length && document.getElementById("ProductGridContainer")) {
      FacetFiltersForm.scrollYToRestore = window.scrollY;
      FacetFiltersForm.scrollXToRestore = window.scrollX;
    }
    const container = document.getElementsByClassName("thb-filter-count");
    const productGridContainer = document.getElementById("ProductGridContainer");
    if (productGridContainer) {
      const collectionElement = productGridContainer.querySelector(".collection");
      if (collectionElement) collectionElement.classList.add("loading");
    }
    for (var item of container) item.classList.add("loading");

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
    FacetFiltersForm.updateFilteredProducts(false);
    FacetFiltersForm.updateFilteredProductCount();
    document.querySelectorAll('.swatch-btn.active').forEach(swatchEl => FacetFiltersForm.updateSwatchInfo(swatchEl));

    const y = FacetFiltersForm.scrollYToRestore;
    const x = FacetFiltersForm.scrollXToRestore;
    if (y !== null && y !== undefined) {
      FacetFiltersForm.scrollYToRestore = null;
      FacetFiltersForm.scrollXToRestore = null;
      const applyScroll = () => window.scrollTo(x ?? window.scrollX, y);
      requestAnimationFrame(() => {
        requestAnimationFrame(applyScroll);
      });
      setTimeout(applyScroll, 100);
    }
  }

  static renderProductCount(html) {
    let count = "";
    const doc = new DOMParser().parseFromString(html, "text/html");
    const countElement = doc.getElementById("ProductCount");
    if (countElement) count = countElement.innerHTML;
    const container = document.getElementsByClassName("thb-filter-count");
    for (var item of container) {
      item.innerHTML = count;
      item.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter");

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.querySelector("summary")?.textContent?.trim().toLowerCase() ===
          jsFilter.querySelector("summary")?.textContent?.trim().toLowerCase()
        : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter((element) => {
      return !matchesIndex(element) && element.querySelector("summary")?.textContent?.trim() !== "";
    });

    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const newTitle = element.querySelector("summary")?.textContent?.trim().toLowerCase();
      if (!newTitle) return;
      const jsFilters = document.querySelectorAll(".js-filter");
      jsFilters.forEach((currentFilter) => {
        const currentTitle = currentFilter.querySelector("summary")?.textContent?.trim().toLowerCase();
        if (currentTitle === newTitle) currentFilter.replaceWith(element.cloneNode(true));
      });
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const clickedFilter = event?.target?.closest(".js-filter");
      if (clickedFilter) FacetFiltersForm.renderCounts(countsToRender, clickedFilter);
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".active-facets"];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });
    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [".mobile-filter-count"];
    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");
    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML = source.querySelector(".facets__selected").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    const productGrid = document.getElementById("product-grid");
    if (productGrid) return [{ section: productGrid.dataset.id }];
    return [];
  }

  static parseProductSettings(productId) {
    const settingsElement = document.getElementById(`settings-${productId}`);
    if (!settingsElement) return null;
    try {
      return JSON.parse(settingsElement.textContent);
    } catch (error) {
      console.error(`Error parsing settings for product ${productId}:`, error);
      return null;
    }
  }

  static async filterCombinedListingProducts(colorFilters) {
    const productCards = document.querySelectorAll(".product-card");
    if (!colorFilters || colorFilters.length === 0) return;

    for (const productCard of productCards) {
      const productId = productCard.dataset.productId;
      const isCombinedListing = productCard.dataset.isCombinedListing === 'true';
      if (!isCombinedListing) continue;

      const settings = FacetFiltersForm.parseProductSettings(productId);
      if (!settings || !settings.product_gids || settings.product_gids.length === 0) continue;

      try {
        const productDetails = await Promise.all(settings.product_gids.map(fetchProductDetails));
        let hasAvailableColorVariant = false;

        for (const productDetail of productDetails) {
          if (!productDetail || (productDetail.metafield && productDetail.metafield.value === "true")) continue;

          if (productDetail.variants && productDetail.variants.edges) {
            for (const edge of productDetail.variants.edges) {
              const variant = edge.node;
              if (!variant.available || variant.inventoryQuantity <= 0) continue;

              for (const option of variant.selectedOptions) {
                if (option.name.toLowerCase() === 'color' || option.name.toLowerCase() === 'colour') {
                  const variantColor = option.value.toLowerCase();
                  if (colorFilters.some(filter => filter.toLowerCase() === variantColor)) {
                    hasAvailableColorVariant = true;
                    break;
                  }
                }
              }

              if (!hasAvailableColorVariant && productDetail.color && productDetail.color.references) {
                for (const reference of productDetail.color.references.edges) {
                  const colorReference = reference.node;
                  const labelField = colorReference.fields.find(f => f.key === 'label');
                  if (labelField) {
                    const metafieldColor = labelField.value.toLowerCase();
                    if (colorFilters.some(filter => filter.toLowerCase() === metafieldColor)) {
                      hasAvailableColorVariant = true;
                      break;
                    }
                  }
                }
              }
              if (hasAvailableColorVariant) break;
            }
          }
          if (hasAvailableColorVariant) break;
        }

        if (!hasAvailableColorVariant) {
          productCard.style.display = 'none';
          productCard.classList.add('filtered-out');
        } else {
          productCard.style.display = '';
          productCard.classList.remove('filtered-out');
        }
      } catch (error) {
        console.error(`Error filtering product ${productId}:`, error);
        productCard.style.display = '';
        productCard.classList.remove('filtered-out');
      }
    }

    FacetFiltersForm.updateFilteredProductCount();
  }

  static updateFilteredProductCount() {
    // Count cards visible in DOM (Liquid-filtered ones never exist, JS-hidden ones have filtered-out class)
    const allCards = document.querySelectorAll('.product-card');
    const visibleCards = document.querySelectorAll('.product-card:not(.filtered-out)');
    const visibleLis = document.querySelectorAll('#product-grid li:not([style*="display: none"])');

    // Use visible li count as most accurate — reflects both Liquid and JS filtering
    const visibleCount = visibleLis.length || visibleCards.length;
    const totalCount = allCards.length;

    const countElements = document.querySelectorAll('.thb-filter-count, .mobile-filter-count');
    countElements.forEach(el => {
      if (!el) return;
      const label = el.querySelector('.facets__label');
      const target = label || el;
      if (visibleCount === totalCount) {
        target.textContent = `${totalCount} products`;
      } else {
        target.textContent = `${visibleCount} of ${totalCount} products`;
      }
    });

    FacetFiltersForm.showNoResultsIfEmpty(visibleCount);
  }

  static showNoResultsIfEmpty(visibleCount) {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const existingMsg = grid.querySelector('.js-filter-no-results');

    if (visibleCount === 0) {
      if (!existingMsg) {
        const msg = document.createElement('li');
        msg.className = 'js-filter-no-results';
        msg.style.cssText = 'grid-column: 1 / -1; padding: 60px 20px; text-align: center;';
        msg.innerHTML = `
          <p style="font-size: 1.1em; margin: 0 0 12px;">No products match your selected filters.</p>
          <p style="margin: 0;">
            <a href="${window.location.pathname}" style="text-decoration: underline;">Clear all filters</a>
            to see all products.
          </p>
        `;
        grid.appendChild(msg);
      }
    } else {
      existingMsg?.remove();
    }
  }

  static async checkColorVariantAvailability(productDetails, colorFilters) {
    if (!productDetails || !productDetails.variants || !productDetails.variants.edges) return false;

    let colorValues = [];
    if (productDetails.color && productDetails.color.references && productDetails.color.references.edges.length) {
      colorValues = productDetails.color.references.edges
        .map(edge => {
          const labelField = edge.node.fields.find(f => f.key === 'label');
          return labelField ? labelField.value : null;
        })
        .filter(Boolean)
        .map(val => val.toLowerCase());
    }

    for (const edge of productDetails.variants.edges) {
      const variant = edge.node;
      if (!variant.available) continue;
      const colorOption = variant.selectedOptions.find(
        opt => opt.name.toLowerCase() === 'color' || opt.name.toLowerCase() === 'colour'
      );
      if (colorOption && colorFilters.some(filter => colorOption.value.toLowerCase() === filter.toLowerCase())) return true;
      if (colorOption && colorValues.length && colorValues.includes(colorOption.value.toLowerCase())) {
        if (colorFilters.some(filter => colorOption.value.toLowerCase() === filter.toLowerCase())) return true;
      }
    }
    return false;
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData);
    document.getElementsByTagName("body")[0].classList.remove("open-cc");
    document.getElementById("Facet-Drawer").classList.remove("active");

    // Clean up default price params (don't add to URL when at min=0 or max=range_max)
    if (searchParams.get('filter.v.price.gte') === '0' || searchParams.get('filter.v.price.gte') === '0.00') {
      searchParams.delete('filter.v.price.gte');
    }
    const slider = document.querySelector('.price_slider');
    if (slider) {
      const sliderMax = parseFloat(slider.dataset.max).toFixed(2);
      if (parseFloat(searchParams.get('filter.v.price.lte')).toFixed(2) === sliderMax) {
        searchParams.delete('filter.v.price.lte');
      }
    }

    FacetFiltersForm.renderPage(searchParams.toString(), event);

    setTimeout(async () => {
      const productCards = document.querySelectorAll(".product-card-swatch");
      const productIds = Array.from(productCards).map((card) => card.dataset.productId);

      for (const productId of productIds) {
        const settings = FacetFiltersForm.parseProductSettings(productId);
        const productDetails = await Promise.all(settings.product_gids.map(fetchProductDetails));

        let uniqueColors = new Map();
        let counter = { count: 0 };

        for (const productDetail of productDetails) {
          if (productDetail && (!productDetail.metafield || productDetail.metafield.value !== "true")) {
            let primaryImagesrc = "";
            let secondaryImagesrc = "";
            if (productDetail && productDetail.images && productDetail.images.edges) {
              const images = productDetail.images.edges.map((edge) => edge.node);
              images.forEach((image, index) => {
                if (index === 0) primaryImagesrc = image.src;
                if (index === 1) secondaryImagesrc = image.src;
              });
            }
            await processProductDetails(
              productDetail,
              settings.featured_image_id,
              document.getElementById("swatch_section_" + productId),
              productId,
              primaryImagesrc,
              secondaryImagesrc,
              settings.custom_handle,
              uniqueColors,
              counter
            );
            if (counter.count >= 6) break;
          }
        }
      }

      document.querySelectorAll("product-card").forEach((card) => card.enableSwatches());
    }, 4000);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const anchor = event.target.closest("a");
    if (!anchor) return;
    FacetFiltersForm.toggleActiveFacets();
    const href = anchor.href;
    const url = href.indexOf("?") === -1 ? "" : href.slice(href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.scrollYToRestore = null;
FacetFiltersForm.scrollXToRestore = null;
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      const anchor = event.target.closest("a");
      if (!anchor || !this.contains(anchor)) return;
      event.preventDefault();
      const form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");
      if (form) form.onActiveFilterClick(event);
    });
  }
}

customElements.define("facet-remove", FacetRemove);

class PriceSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector(".price_slider"),
      amounts = this.querySelector(".price_slider_amount"),
      args = {
        start: [
          parseFloat(slider.dataset.minValue || 0),
          parseFloat(slider.dataset.maxValue || slider.dataset.max),
        ],
        connect: true,
        step: 1,
        direction: document.dir,
        range: {
          min: 0,
          max: parseFloat(slider.dataset.max),
        },
      },
      event = new CustomEvent("input"),
      form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");

    if (slider.classList.contains("noUi-target")) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on("update", function (values) {
      amounts.querySelector(".field__input_min").value = values[0];
      amounts.querySelector(".field__input_max").value = values[1];
    });
    slider.noUiSlider.on("change", function (values) {
      form.querySelector("form").dispatchEvent(event);
    });
  }
}
customElements.define("price-slider", PriceSlider);

window.addEventListener("load", () => {
  new FacetsToggle();
});

// Re-run filters and reinitialize images after pagination loads new products.
// Hooks into both the theme's custom event AND patches renderProducts directly
// as a fallback in case dispatchCustomEvent doesn't fire on document.
function onPaginationLoad() {
  FacetFiltersForm.updateFilteredProducts(false);

  // Reinitialize lazy-loaded images on newly appended product cards
  document.querySelectorAll('product-card img[loading="lazy"]').forEach(img => {
    if (img.dataset.src && !img.src.includes(img.dataset.src)) {
      img.src = img.dataset.src;
    }
    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
    }
  });

  // Re-enable product-card web components on new items
  document.querySelectorAll('product-card').forEach(card => {
    if (typeof card.enableSwatches === 'function') {
      card.enableSwatches();
    }
  });
}

// Listen via theme custom event
document.addEventListener('pagination:page-changed', onPaginationLoad);

// Also patch the Pagination custom element's renderProducts directly as a fallback
document.addEventListener('DOMContentLoaded', () => {
  const paginationEl = customElements.get('pagination-theme');
  if (paginationEl) {
    const originalRenderProducts = paginationEl.prototype.renderProducts;
    paginationEl.prototype.renderProducts = function(html, url) {
      originalRenderProducts.call(this, html, url);
      // Small delay to let DOM append finish before running filters
      setTimeout(onPaginationLoad, 100);
    };
  }
});
